/** @format */

export const actionTypes = {
  DATABASE_ADD: 'database/DATABASE_ADD',
  DATABASE_REMOVE: 'database/DATABASE_REMOVE',
  DATABASE_DEFAULT: 'database/DATABASE_DEFAULT',

  DATABASE_FETCH_REQUEST: 'database/DATABASE_FETCH_REQUEST',
  DATABASE_FETCH_SUCCESS: 'database/DATABASE_FETCH_SUCCESS',
  DATABASE_FETCH_ERROR: 'database/DATABASE_FETCH_ERROR',
}

export const database = {
  add: (data) => ({
    type: actionTypes.DATABASE_ADD,
    payload: data,
  }),
  remove: (data) => ({
    type: actionTypes.DATABASE_REMOVE,
    payload: data,
  }),
  default: () => ({
    type: actionTypes.DATABASE_DEFAULT,
  }),
  fetch: {
    request: () => ({
      type: actionTypes.DATABASE_FETCH_REQUEST,
    }),
    success: (payload) => ({
      type: actionTypes.DATABASE_FETCH_SUCCESS,
      payload,
    }),
    error: (message) => ({
      type: actionTypes.DATABASE_FETCH_REQUEST,
      payload: message,
    }),
  },
}
